/* global math ElementEleda Question*/
import { currentLanguage, getEledaMessage } from "../../../lang/EledaMessages";
import {
  applyColorAndSizeStyleToNode,
  applyAlignmentStyleToDiv,
} from "./Utils-Html-Style.mjs";
//Utils import
import { isNumeric } from "../numeric/Utils-Numeric.mjs";
import {
  isConvertibleIntoLatex,
  convertObjectIntoLatex,
  renderLatexIntoNode,
} from "./Utils-Latex-Rendering";

/**
 * * Set Attributes settings to an object. If it's an Eleda object use method to apply treatment
 * otherwise just add attributes to std object to retrieve it afterwards
 * @param {*} object
 * @param {*} json
 * @returns
 */
export function setEledaAttributes(object, json) {
  console.log("Utils setEledaAttributes ");
  var objectWithAttributes = object;
  console.log("setEledaAttributes typeof object ", typeof object);
  if (objectWithAttributes instanceof ElementEleda) {
    object.setEledaAttributes(json);
  } else if (objectWithAttributes instanceof Object) {
    objectWithAttributes.eledaAttributes = {
      ...objectWithAttributes.eledaAttributes,
      ...json,
    };
  }
  return objectWithAttributes;
}

/**
 *
 * @param object
 * @param node
 */
export function renderIntoDebugNode(text) {
  try {
    document.getElementById("debug").appendChild(document.createTextNode(text));
  } catch (e) {
    console.log("debug ID Node is not present");
  }
}

/**
 *
 * @param object
 * @param node
 */
export function renderIntoNode(object, node) {
  //Render value shape Question  because activity class render only statement shape Question
  console.log("renderIntoNode");

  if (object instanceof Question) {
    console.log("renderIntoNode question");
    if (object.getMutationShape() == "value") {
      object.render(node);
    }
  } else if (object instanceof ElementEleda) {
    //  console.log("renderIntoNode ElementEleda", object);
    object.render(node);
    //  console.log(object, " is an ElementEleda object");
  } else {
    //For any other object types analysis it separatly
    // console.log("renderIntoNode no type", object);
    node.appendChild(convertIntoNode(object));
  }
}
/**
 * Produce NodeHtml depending on object' type
 */
export function convertIntoNode(object) {
  console.log("convertIntoNode", object);
  var nodeTemp;
  //use Number.isNaN to be sure to test if object is a Number with NaN value
  if (
    object === undefined ||
    object === null ||
    Number.isNaN(object) ||
    ((["number", "Complex", "BigNumber", "Fraction", "Unit"].includes(
      math.typeOf(object)
    ) ||
      object instanceof Element_Fraction) &&
      math.isNaN(object))
  ) {
    console.log(" is null undefined or Number NaN");
    var stringReturned = new String(getEledaMessage("undefinedOrNull"));
    nodeTemp = document.createTextNode(stringReturned);
  }
  // instanceof doesn't work properly with boolean element => use of typeof instead
  else if (typeof object == "boolean") {
    console.log(" is a boolean object");
    if (object) {
      nodeTemp = document.createTextNode(getEledaMessage("true"));
    } else {
      nodeTemp = document.createTextNode(getEledaMessage("false"));
    }
  } else if (
    object instanceof HTMLElement ||
    object instanceof DocumentFragment
  ) {
    nodeTemp = object;
    console.log(object, " is an HTMLElement or DocumentFragmentobject");
  }
  //MATHJS NODE / EXPRESSION
  else if (isConvertibleIntoLatex(object)) {
    nodeTemp = document.createElement("span");
    renderLatexIntoNode(convertObjectIntoLatex(object), nodeTemp);
  }
  //ARRAY/LIST JS
  else if (Array.isArray(object)) {
    console.log(object, "is a Array... convertIntoNode all elts");

    nodeTemp = document.createElement("span");
    nodeTemp.appendChild(document.createTextNode("["));
    object.forEach((item, index) => {
      nodeTemp.appendChild(convertIntoNode(item));
      if (index < object.length - 1)
        nodeTemp.appendChild(document.createTextNode("; "));
    });
    nodeTemp.appendChild(document.createTextNode("]"));
  } else if (isNumeric(object)) {
    // If not Math.JS object and simple JS Number (Attention : do this test after MathJS objects, otherwise test cast fraction into decimal)
    //Si c'est un number ()
    nodeTemp = document.createTextNode(renderNumeric(object));
    console.log(object, "is a numeric or decimal");
  }
  //TEST IF IT'S a STRING OBJECT NUMBER or BigNumber
  //it means that is was created by custom eleda style: color, size...
  else if (
    object instanceof String ||
    object instanceof Number ||
    object instanceof math.BigNumber
  ) {
    nodeTemp = document.createElement("span");

    nodeTemp.appendChild(
      document.createTextNode(
        object instanceof Number || object instanceof math.BigNumber
          ? renderNumeric(object)
          : object
      )
    );
  } else {
    console.log(object, " is a unknow type");
    nodeTemp = document.createTextNode(object);
  }
  if (object) {
    applyColorAndSizeStyleToNode(nodeTemp, object.style);
  }
  return nodeTemp;
}
/**
 * Retrieve active (not disabled) inputfields (html and math-field)
 * @returns Array
 */
export function getActivityInputFields() {
  if (document.getElementById("activity")) {
    return [
      ...document.getElementById("activity").getElementsByTagName("input"),
      ...document.getElementById("activity").getElementsByTagName("math-field"),
    ].filter((input) => !input.disabled);
  } else {
    return [];
  }
}

export function isActivityMultipleOpenQuestions() {
  console.log(
    "isActivityMultipleOpenQuestions",
    document.getElementsByClassName("open question").length,
    document.getElementsByClassName("open question").length === 1
  );
  return document.getElementsByClassName("open question").length === 1;
}

/**
 * Render Numeric (mathjs bignumber or js numerics)
 * Inspired from Ref : https://stackoverflow.com/questions/18082/validate-decimal-numbers-in-javascript-isnumeric/174921#174921
 * @param {} n
 * @returns a string
 */
export function renderNumeric(n) {
  let roundNumber = n;
  let returnObject;
  if (roundNumber === 0) {
    //because roundNumber could be 0 +0, -0 (js manages signed zero but they are equal)=> just reaffect to unsigned 0 to not display sign
    returnObject = "0";
  } else {
    let intlFct = new Intl.NumberFormat(currentLanguage);
    let options = intlFct.resolvedOptions();
    // MATHJS workaround precision JS issue : Limit precision to 14 digits instead of 16 to prevent JS error precision e.g. 0.1 +  0.2 => 0.30000000000000004
    //Ref : https://mathjs.org/docs/datatypes/numbers.html#roundoff-errors

    //roundNumber = roundTo14Digits(roundNumber);
    returnObject = new Intl.NumberFormat(options.locale, {
      maximumFractionDigits: 20,
    }).format(roundNumber);
  }
  return returnObject;
}

/**
 * Render indice sticker feedback
 * @param {*} indice indice reference
 * @param {*} type  depending on learner's answer (True : 1, False : 2)
 * @returns
 */
export function createHtmlNodeReferenceFeedback(indice) {
  let htmlNode = document.createElement("span");
  htmlNode.classList.add("reference-feedback");
  let textIndice = document.createTextNode(indice);
  htmlNode.appendChild(textIndice);
  return htmlNode;
}

/**
 * Render feedback Html Node
 * @param {*} element
 * @param {*} type feedbackStd (True : 1, False : 2), feedbackCustom : 10, feedbackReferenceIndice : 20, feedbackSolution : 30
 * @param {*} header
 * @returns HtmlNode
 */
export function createHtmlNodeFeedback(element, type, header) {
  console.log("element", element);
  var feedbackHtmlNode = document.createElement("div");
  //Set Style named by type
  feedbackHtmlNode.classList.add("feedback-type-" + type);
  //Append
  if (header) {
    feedbackHtmlNode.appendChild(document.createTextNode(header));
  }
  //Append element
  if (element !== null && element !== undefined && element.style) {
    applyAlignmentStyleToDiv(feedbackHtmlNode, element.style);
  }
  renderIntoNode(element, feedbackHtmlNode);
  return feedbackHtmlNode;
}

/********************** COMMON FUNCTIONS *********************/

/**
 * Convert String to DOM element
 * @param  {String} text
 * @returns {DOM}
 */
export function createNodeFromHtmlString(text) {
  return document.createRange().createContextualFragment(text);
}

/**
 * Convert String to DOM element
 * @param  {String} text
 * @returns {DOM}
 */
export function removeAllChildrenOfId(id) {
  try {
    let node = document.getElementById(id);
    if (node) {
      /*
      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }
      node.textContent = "";
      */
      //      node.replaceChildren();
      node.innerHTML = "";
    }
  } catch (e) {
    console.log("Error removeAllChildrenOfId " + id + " not found");
  }
}

/**
 * Convert String to DOM element
 * @param  {String} text
 * @returns {DOM}
 */
export function removeAllChildrenOfClassName(nodeRoot, name) {
  try {
    //Convert into array getElementsByClassName to be able to use forEach (otherwise catch is triggered)
    let nodes = [...nodeRoot.getElementsByClassName(name)];
    nodes.forEach((node) => {
      node.remove();
    });
  } catch {
    console.log("Error removeAllChildrenOfName " + name + " not found");
  }
}

/**
 * Retrieve selected items in a HTML select/option (multiple or not) and fieldset/checkbox or radio button
 * @param className classname
 * @param idName id of the htmlElement (optionnal)
 * @returns
 */
export function getSelectedElements(className, idName = null) {
  /*console.log(
    "Utils.mjs : getSelectedElements: looking for elements id: ",
    idName,
    " className: ",
    className
  );*/
  var elements = [];
  var checkedElements = [];
  if (idName == null) {
    elements = document.getElementsByClassName(className);
  } else {
    elements = document
      .getElementById(idName)
      .getElementsByClassName(className);
  }
  //console.log(elements[0].tagName);
  //TEST first element of the list
  //RADIO OR CHECKBOX
  if (elements[0].tagName == "INPUT") {
    [...elements].forEach((element) => {
      if (element.checked) {
        checkedElements.push(element.id);
      }
    });
    //SELECT DROPDOWN SIMPLE OR MULTIPLE
  } else if (elements[0].tagName == "OPTION") {
    [...elements].forEach((element) => {
      if (element.selected) {
        checkedElements.push(element.value);
      }
    });
  }
  return checkedElements;
}

export function uuid() {
  var uuid = "",
    i,
    random;
  for (i = 0; i < 32; i++) {
    random = (Math.random() * 16) | 0;
    if (i == 8 || i == 12 || i == 16 || i == 20) {
      uuid += "-";
    }
    uuid += (i == 12 ? 4 : i == 16 ? (random & 3) | 8 : random).toString(16);
  }
  return uuid;
}
